import React, { useState, useEffect, useRef } from 'react';
import { getPublicAds, trackAd } from '../../services/adsService';
import './AdBanner.css';

const AdBanner = ({ placementSlug, style, className = '' }) => {
  const [ads, setAds] = useState([]);
  const [placement, setPlacement] = useState(null);
  const trackedRef = useRef(new Set());

  useEffect(() => {
    if (!placementSlug) return;
    let cancelled = false;

    const loadAds = async () => {
      try {
        const data = await getPublicAds(placementSlug);
        if (!cancelled) {
          setAds(data.ads || []);
          setPlacement(data.placement || null);
        }
      } catch (e) {
        // Ads are non-critical — fail silently
      }
    };
    loadAds();
    return () => { cancelled = true; };
  }, [placementSlug]);

  // Track view when ad becomes visible
  const handleAdVisible = (adId) => {
    if (!trackedRef.current.has(adId)) {
      trackedRef.current.add(adId);
      trackAd(adId, placementSlug, 'view');
    }
  };

  const handleAdClick = (adId) => {
    trackAd(adId, placementSlug, 'click');
  };

  if (!ads.length) return null;

  return (
    <div className={`ad-banner-container ${className}`} style={style}>
      {ads.map((ad) => (
        <a
          key={ad.id}
          href={ad.linkUrl || '#'}
          target={ad.linkUrl ? '_blank' : '_self'}
          rel="noopener noreferrer"
          className="ad-banner-link"
          onClick={() => handleAdClick(ad.id)}
        >
          <img
            src={ad.imageUrl?.startsWith('http') ? ad.imageUrl : `${ad.imageUrl}`}
            alt={ad.companyName || 'Advertisement'}
            className="ad-banner-image"
            onLoad={() => handleAdVisible(ad.id)}
            style={{
              maxWidth: '100%',
              height: 'auto'
            }}
          />
          <span className="ad-banner-label">Ad</span>
        </a>
      ))}
    </div>
  );
};

export default AdBanner;
